import axios from "axios";

// Use same-origin relative API base so cookies stay first‑party and Nginx/Cloud Run
// proxy (/api -> backend) can be used in all environments.
// const API = axios.create({
//   baseURL: "/api",
//   withCredentials: true,
// });

// Empty string = same-origin: requests go to `/api/*` on the current host, which
// the shared load balancer routes to the backend. This keeps the session cookie
// first-party (fixes incognito / third-party-cookie blocking). Local dev sets
// REACT_APP_BACKEND_URL=http://localhost:8080 to reach the backend cross-port.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true, // Keep for cookie-based auth compatibility
});

// Auth
export const signup = (formData) => {
  const params = new URLSearchParams();
  params.append('email', formData.email);
  params.append('password', formData.password);
  params.append('name', formData.name);
  return API.post("/auth/pre-signup", params);
};

export const login = (formData) => {
  const params = new URLSearchParams();
  params.append('email', formData.email);
  params.append('password', formData.password);
  return API.post("/auth/login", params);
};

export const getMe = () => API.get("/auth/me");
export const logout = () => API.get("/auth/logout");
export const googleLogin = () => {
  // Use environment variable for Google login redirect
  window.location.href = `${BACKEND_URL}/api/auth/google/login`;
};

// Threads
export const newThread = (userId) =>
  API.post("/threads/new", null, { params: { user_id: userId } });

export const listThreads = (userId) =>
  API.get("/threads", { params: { user_id: userId } });

export const updateThreadTitle = (threadId, title, userId) =>
  API.put(`/threads/${threadId}`, { title }, { params: { user_id: userId } });

export const deleteThread = (threadId, userId) =>
  API.delete(`/threads/${threadId}`, { params: { user_id: userId } });

// Chat
export const sendMessage = (threadId, userId, message) =>
  API.post("/chat/send", null, {
    params: { thread_id: threadId, user_id: userId, message },
  });

export const getHistory = (userId, threadId) =>
  API.get(`/chat/history/${userId}/${threadId}`);

export default API;
